export default "__VITE_ASSET__B9mJKy_o__"